import '../stylesheets/style.scss'
// import "babel-polyfill ";

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { BrowserRouter } from 'react-router-dom'
import { getDefaultLanguage, applyMessages } from "./ui/messages";
import { messagesFetch } from "./routes";
import reduce from "./storage/reduce";

export let store

function startUp () {
    const store = createStore(reduce);
    // init(store); // setup websocket listeners etc
    window.reduxStore = store
    const App = require("./app.jsx").App // require() is used here so that window.reduxStore is defined BEFORE components are evaluated
    messagesFetch(getDefaultLanguage(), msgs => {
        applyMessages(msgs)
        renderContent(<App/>)
    }) // Render content once messages have been fetched

    return store;
}

store = startUp()

function renderContent(content){
    render(
        <Provider store={store}>
            <BrowserRouter>
                {content}
            </BrowserRouter>
        </Provider>,
        document.getElementById('main')
    )
}

// render(<App/>, document.getElementById('main'))
